import { useEffect } from "react";
import ProfileHeader from "./components/profile.header";
import ProfileOverview from "./components/profile.overview";
import SavedCarModal from "./modals/saved.car.modal";
import ProfileInfoModal from "./modals/profile.info.modal";
import ProfileReferralModal from "./modals/profile.referral.modal";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../redux/reducer/profile.reducer";

export default function Profile() {
  const dispatch = useDispatch();
  const { isOpenProfileInfoModal, isOpenReferralModal, isOpenSavedCarsModal } =
    useSelector((state) => state.modal);
  const { token, username } = useSelector((state) => state.common);
  const { profileInfo, referralInfo } = useSelector((state) => state.profile);

  const handleShareReferral = async () => {
    const referralCode =
      referralInfo?.code ||
      profileInfo?.referral?.code ||
      profileInfo?.referral_info?.code ||
      profileInfo?.referral_code?.code ||
      profileInfo?.referral_code ||
      profileInfo?.code ||
      localStorage.getItem("own_referral_code");
    const referralName =
      profileInfo?.name ||
      profileInfo?.username ||
      profileInfo?.user?.name ||
      profileInfo?.user?.username ||
      localStorage.getItem("name") ||
      username;
    const referralUrl = new URL("/", window.location.origin);

    if (referralCode)
      referralUrl.searchParams.set("referral_code", referralCode);
    if (referralName) referralUrl.searchParams.set("referrer", referralName);

    try {
      if (navigator.share) {
        await navigator.share({
          title: "DCAR Refer and Earn",
          url: referralUrl.toString(),
        });
        return;
      }

      await navigator.clipboard.writeText(referralUrl.toString());
    } catch (error) {
      if (error?.name !== "AbortError") {
        await navigator.clipboard?.writeText(referralUrl.toString());
      }
    }
  };

  useEffect(() => {
    if (token && username) {
      dispatch(getProfile());
    }
  }, [dispatch, token, username]);

  return (
    <article className="profile">
      <ProfileHeader />
      <ProfileOverview />

      {isOpenSavedCarsModal && <SavedCarModal />}
      {isOpenProfileInfoModal && <ProfileInfoModal />}
      {isOpenReferralModal && (
        <ProfileReferralModal onShare={handleShareReferral} />
      )}

    </article>
  );
}
